<template>
    <div class="hero text-center pt-5">
        <div class="hero-image">
            <img :src="require('@/assets/images/hero.png')" width="100%" />
          </div>
    </div>
</template>

<script>
export default {
  name: 'HeroPictureItem'
}
</script>
